import { List } from "immutable";
import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

import CheckboxListView from "../../components/checkboxList/CheckboxListView";
import FilterField from "../../components/filter/FilterField";
import FilterRow from "../../components/filter/FilterRow";
import FormButton from "../../components/form/FormButton";
import FormTextField from "../../components/form/FormTextField";
import SplitButton from "../../components/form/SplitButton";
import Icon from "../../components/interface/Icon";
import NavigationToolbar from "../../components/navigationToolbar";
import { popoverOrPortal } from "../../components/portal/popoverOrPortal";
import { withScreenContext } from "../../components/screen/ScreenContext";
import keyConstants from "../../constants/keyConstants";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";

const isReadonly = preprocessorQuery.isReadonly();
const isHarvard = preprocessorQuery.isHarvard();

const popoverTargetId = "filterExposedIcon";

class FilterPanelHeader extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      exposedPopoverOpen: false,
      savePopoverOpen: false,
      saveName: null
    };
    this.toggleSavePopover = this.toggleSavePopover.bind(this);
    this.saveNameChanged = this.saveNameChanged.bind(this);
    this.saveBtnClick = this.saveBtnClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.renderExposedCheckboxes = this.renderExposedCheckboxes.bind(this);
    this.toggleExposedPopover = this.toggleExposedPopover.bind(this);
  }

  getSaveBtnId() {
    return "currentFilterSave-" + this.props.filterId;
  }

  getLoadBtnId() {
    return "currentFilterLoad-" + this.props.filterId;
  }

  getSaveButton() {
    const saveId = this.getSaveBtnId();
    return (
      <Fragment>
        {this.props.filterIsActive ? (
          <SplitButton label="Save" onClick={this.toggleSavePopover} id={saveId} small={true} icon="" />
        ) : null}
        {this.state.savePopoverOpen ? this.renderSavePopover() : null}
      </Fragment>
    );
  }

  getLoadOptions() {
    const options = this.props.savedFilters
      .map((label, id) => ({
        id,
        label,
        canDelete: true
      }))
      .toList();
    return List([
      {
        title: "",
        id: "loadFilterOptionGroup",
        options: options,
        showTitle: false,
        showSearch: false,
        onSelectOption: this.props.onLoadFilter
      }
    ]);
  }

  getLoadButton() {
    return this.props.savedFilters.size > 0 ? (
      <SplitButton
        className="filterHeaderLoadButton"
        popoverClassName="filterHeaderSplitPopover"
        id={this.getLoadBtnId()}
        label="Load"
        optionGroups={this.getLoadOptions()}
        small={true}
        icon=""
        onDeleteOption={this.props.onDeleteFilter}
        showDownArrow={false}
      />
    ) : null;
  }

  getSaveActionsButtons() {
    return isReadonly ? null : (
      <div className="filterHeaderSaveButtons">
        {this.getSaveButton()}
        {this.getLoadButton()}
      </div>
    );
  }

  toggleSavePopover() {
    this.setState({
      savePopoverOpen: !this.state.savePopoverOpen
    });
  }

  toggleExposedPopover() {
    this.setState({
      exposedPopoverOpen: !this.state.exposedPopoverOpen
    });
  }

  saveNameChanged(name) {
    this.setState({
      saveName: name
    });
  }

  saveBtnClick() {
    const saveValue = this.state.saveName.trim();
    if (saveValue) {
      this.props.onSaveFilter(this.props.filterId, saveValue);
      this.toggleSavePopover();
      this.setState({
        saveName: null
      });
    }
  }

  onKeyDown(e, onEnter) {
    if (e.key === keyConstants.Enter) {
      onEnter();
    }
  }

  renderSaveForm() {
    return (
      <div className="filterSaveBox" onKeyDown={e => this.onKeyDown(e, this.saveBtnClick)}>
        <FilterRow>
          <FilterField flex={3}>
            <FormTextField
              value={this.state.saveName}
              placeholder="Enter save name"
              autoFocusOnEmpty={true}
              onChange={this.saveNameChanged}
              continuouslyUpdates={true}
            />
          </FilterField>
          {/* #!if readonly !== true */}
{/* <FilterField flex={1}>*/}
{/* <FormButton label="Save" disabled={!this.state.saveName} onClick={this.saveBtnClick} />*/}
{/* </FilterField>*/}
          {/* #!endif */}
        </FilterRow>
      </div>
    );
  }

  renderSavePopover() {
    const saveId = this.getSaveBtnId();

    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `filterSavePopover`,
      placement,
      hideArrow,
      isOpen: this.state.savePopoverOpen,
      target: saveId,
      toggle: this.toggleSavePopover
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggleExposedPopover}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>{this.renderSaveForm()}</PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  renderExposedCheckboxes() {
    const options = this.props.allFilterGroups.map(filter => {
      return {
        label: filter.label,
        value: filter.value,
        selected: this.props.exposedFilterTypes.includes(filter.value)
      };
    });
    return <CheckboxListView items={options} onChange={this.props.setExposedFilterType} />;
  }

  renderExposedIcon() {
    return isReadonly ? null : (
      <Icon
        color="iconMono"
        icon="options"
        onClick={this.toggleExposedPopover}
        id={popoverTargetId}
        tooltip="Configure Filter Options"
      />
    );
  }

  renderExposedPopover() {
    let placement = "bottom-end";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `filterExposedPopover`,
      placement,
      hideArrow,
      isOpen: this.state.exposedPopoverOpen,
      target: popoverTargetId,
      toggle: this.toggleExposedPopover
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggleExposedPopover}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>
          <div className="filterPopoverHeading">Filters shown by default:</div>
          {this.renderExposedCheckboxes()}
        </PopoverBody>
      </Fragment>
    );
    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return isHarvard ? null : (
      <div className="filterPanelHeader">
        <span>Filter</span>
        {this.getSaveActionsButtons()}
        {this.renderExposedIcon()}
        {this.state.exposedPopoverOpen ? this.renderExposedPopover() : null}
        {this.state.savePopoverOpen ? this.renderSavePopover() : null}
      </div>
    );
  }
}

FilterPanelHeader.propTypes = {
  allFilterGroups: PropTypeShapes.listOptionList.isRequired,
  exposedFilterTypes: ImmutablePropTypes.list.isRequired,
  setExposedFilterType: PropTypes.func.isRequired,
  onSaveFilter: PropTypes.func.isRequired,
  onDeleteFilter: PropTypes.func.isRequired,
  filterId: PropTypes.string.isRequired,
  filterIsActive: PropTypes.bool.isRequired,
  title: PropTypes.string,
  backText: PropTypes.string,
  savedFilters: ImmutablePropTypes.map.isRequired,
  onLoadFilter: PropTypes.func.isRequired,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = FilterPanelHeader;
//#!if iOS === true
// exportedView = withScreenContext(FilterPanelHeader);
//#!endif
export default exportedView;
